module.exports = __webpack_public_path__ + "img/lg_chpl_tv.92c96bc2.png";